import { render, staticRenderFns } from "./platformHouseholdList copy.vue?vue&type=template&id=7b81b1dc"
import script from "./platformHouseholdList copy.vue?vue&type=script&lang=js"
export * from "./platformHouseholdList copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports